<body>
    <div class="dash">
        <app-sidebar></app-sidebar>
        <div class="dash-app">
            <app-header></app-header>
            <main class="dash-content" style="padding: 20px; margin: 0">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="container">
                                <div *ngIf="curClinic && curClinic[0].clinicName">
                                    <h4 style="display: inline-block;">{{curClinic[0].clinicName}}</h4><img
                                        *ngIf="!isActive" title="Online" class="activeIcon img-fluid"
                                        src="../../../../assets/img/green2.gif">

                                    <button class="btn btn-primary" (click)="onStopAttend()"
                                        style="margin-left: 600px;">
                                        Stop Attending
                                    </button>
                                    <button class="btn btn-warning" (click)="onpauseAttend()">Pause Attending</button>

                                </div>
                                <div class="tokenCard mx-auto">
                                    <div class="card-body text-center">
                                        <div class="font-weight-bold" *ngIf="appArray.length == 0">
                                            No Appointments Available
                                        </div>
                                        <div *ngIf="appArray.length > 0">
                                            <div *ngIf="!activePat">
                                                No Patient is Avaialble at this appointmentnumber - {{ currentPatNum }}
                                            </div>
                                            <div *ngIf="activePat">
                                                <div style="border-bottom: 1px solid grey;">
                                                    <h3 class="card-title">
                                                        {{ activePat?.patientName }}
                                                    </h3>
                                                    <h6 class="card-subtitle mb-2 text-muted">
                                                        AppointmentNumber - {{ activePat?.appointmentNumber }}
                                                    </h6>
                                                </div>
                                                <div class="row rone mt-4">
                                                    <div class="col-md-6">
                                                        <p class="text-muted">
                                                            Form - {{ activePat?.patientId.name }}
                                                        </p>
                                                        <p class="text-muted">
                                                            Age - {{ activePat?.patientAge }} yr
                                                        </p>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <p class="text-muted">
                                                            AppointmentType- {{ activePat?.appointmentType }}
                                                        </p>
                                                        <p class="text-muted">
                                                            Gender-{{ activePat?.patientGender }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" style="margin-top: 20px" *ngIf="appArray.length > 0 ">
                                            <div class="col-xl-6 text-center">
                                                <button type="button" class="btn btn-primary" (click)="onCancel()"
                                                    *ngIf="activePat">
                                                    <span>Skip Patient </span>
                                                </button>
                                            </div>
                                            <div class="container">
                                            <div class="row">
                                                <div class="col-xl-6 text-center" style="margin-top: 20px;">
                                                    <button type="button" class="btn btn-primary" (click)="onNext()">
                                                        <span>Next Patient</span>
                                                    </button>
                                                </div>
                                                <div class="col-xl-6 text-center">
                                                    <button type="button" class="btn btn-primary" data-toggle="modal"
                                                        data-target="#exampleModal">
                                                        <span>Any Number</span>
                                                    </button>
                                                </div>
                                            </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <!-- Button trigger modal -->

                                <!-- Modal -->
                                <div class="modal fade" id="exampleModal" tabindex="-1"
                                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-dialog-scrollable">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                                                <button type="button" class="close" data-dismiss="modal"
                                                    aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                                <table class="table table-hover">
                                                    <thead>
                                                      <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">First</th>
                                                        <th scope="col">Age</th>
                                                        <th scope="col">Phone Number</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      <tr *ngFor="let pat of patdata; let index = index" (click)="changerendomNumber(pat)">
                                                        <th scope="row">{{pat.appointmentNumber}}</th>
                                                        <td>{{pat.patientName}}</td>
                                                        <td>{{pat.patientAge}}</td>
                                                        <td>{{pat.patientId.phoneNo}}</td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                            </div>
                                            <!-- <div class="modal-footer">
                                                <button type="button" class="btn btn-primary">Save changes</button>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                                <ul class="nav nav-tabs">
                                    <li class="nav-item tabscursore">
                                        <a class="nav-link" (click)="onchange('Todaypat')" data-toggle="tab"
                                            [ngClass]="{ active: type == 'Todaypat' }">
                                            <i class="fa fa-users"></i> Today's Patient
                                        </a>
                                    </li>
                                    <li class="nav-item tabscursore">
                                        <a class="nav-link" (click)="onchange('notAvailable')" data-toggle="tab"
                                            [ngClass]="{ active: type == 'notAvailable' }">
                                            <i class="fa fa-users"></i> Not Available
                                        </a>
                                    </li>
                                   
                                </ul>
                            </div>
                            <!--    <div class="card text-center">
                    <div class="card-header">
                      Patient Number - 1
                    </div>
                    <div class="card-body">
                      <h5 class="card-title">Patient Name</h5>
                      <p class="card-text">forWhom Wife</p>
                      <a href="#" class="btn btn-primary">Go somewhere</a>
                    </div>
                    <div class="card-footer text-muted">
                      2 days ago
                    </div>
                  </div>-->
                        </div>
                    </div>
                    <div class="col-md-12 mb-5">
                        <div class="row">
                            <div class="col-md-4">

                            </div>

                            <div class="col-md-4"></div>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="type == 'Todaypat'" class="col-xl-12">
                            <div class="easion-card">
                                <!-- <div class="card-header">
                                    <div class="easion-card-icon">
                                        <i class="fa fa-users"></i>
                                    </div>
                                    <div class="easion-card-title">Today Patient</div>
                                </div> -->
                                <div class="card-body">
                                    <div class="notifications">
                                        <div *ngIf="appArray.length == 0">
                                            <p class="text-center">No patient</p>
                                        </div>
                                        <div *ngIf="appArray.length > 0" class="container row">
                                            <div class="col-1"></div>
                                            <div class="col-3 text-center p-0">Patient Name</div>
                                            <div class="col-2 text-left">Token No.</div>
                                            <div class="col-2 text-left p-0">Patient Phone No.</div>
                                            <div class="col-2 text-left p-0">Address</div>
                                            <div class="col-2 text-left p-0">status</div>
                                        </div>
                                        <div *ngFor="let pat of appArray; let index = index">
                                            <a class=" row container notification mb-2" type="button"
                                                (click)="onCancelClicked(pat, index)">
                                                <div class="col-1">
                                                    <i class="fa fa-user"></i>
                                                </div>
                                                <div class="col-3 text-center p-0">
                                                    {{pat.patientName }}
                                                </div>
                                                <span class="col-2 text-left">{{
                                                    pat.appointmentNumber
                                                    }}</span>
                                                <div class="col-2">{{pat.patientId.phoneNo}}</div>
                                                <div class="col-2">{{pat.address}}</div>
                                                <div *ngIf="pat.appointmentStatus == 'CONFIRMED'" class="col-2">.</div>
                                                <div *ngIf="pat.appointmentStatus == 'PENDING'" class="col-2">Not
                                                    Present</div>
                                                <div *ngIf="pat.appointmentStatus == 'ACTIVE'" class="col-2">Active
                                                </div>
                                                <div *ngIf="pat.appointmentStatus == 'DONE'" class="col-2">Done</div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <button *ngIf="appArray.length > 20" class="btn btn-primary"
                                    (click)="onSeeMoreClicked()">
                                    See More
                                </button>
                            </div>
                        </div>
                        <div *ngIf="type == 'notAvailable'" class="col-xl-12">
                            <div class=" easion-card">
                                <!-- <div class="card-header text-center">
                                    <div class="easion-card-icon">
                                        <i class="fa fa-users"></i>
                                    </div>
                                    <div class="easion-card-title">Late Booking</div>
                                </div> -->
                                <div class="card-body">
                                    <div *ngIf="latePatientArray.length == 0">
                                        <p class="text-center">No patient</p>
                                    </div>
                                    <div *ngIf="latePatientArray.length > 0" class="row">
                                        <div class="col-1"></div>
                                        <div class="col-3 text-center">Patient Name</div>
                                        <div class="col-2 text-left">Token No.</div>
                                        <div class="col-4 p-0">Patient Phone No.</div>
                                    </div>
                                    <div class="notifications"
                                        *ngFor="let sinPat of latePatientArray; let index = index">
                                        <a class="row notification" (click)="onLatePatientClicked(sinPat)">
                                            <div class="col-1">
                                                <i class="fa fa-inbox"></i>
                                            </div>
                                            <div class="col-3 text-center">
                                                {{ sinPat?.patientName }}
                                            </div>
                                            <span class="col-2 text-left">{{
                                                sinPat?.appointmentNumber
                                                }}</span>
                                            <div class="col-4">{{sinPat?.patientId.phoneNo}}</div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</body>